import {
  BtnClose,
  LoadingOverlay,
  MaintenancePageWrapper,
  TutorialImg,
  TutorialWrapper,
  UserCardWrapper,
} from '../../Styled'
import { useState } from 'react'
import ConfirmModal, { CONFIRM_MODAL_TYPE } from 'component/Modal/ConfirmModal'
import UserCard from 'page/SystemConfig/component/IDCard'
import tutorialImg from '../../update-tutorial.jpg'
import { installFromPreload } from 'utils/id-util/update-util'
import { getVisitorId } from 'redux/saga/user'
import { PRELOAD_DATA_LOCAL_STORAGE_KEY } from 'constant/common'
import Loading from 'page/GameLobby/component/Loading'

interface MobileConfigUpdateFlowProps {
  isOpen: boolean
  onClose: () => void
}

export default function MobileConfigUpdateFlow({ isOpen, onClose }: MobileConfigUpdateFlowProps) {
  const [page, setPage] = useState('confirm')

  const [isInstalling, setIsInstalling] = useState(false)

  const onClickUpdate = () => {
    if (isInstalling) {
      return
    }

    setIsInstalling(true)
    installFromPreload(
      getVisitorId(),
      process.env.REACT_APP_PRELOAD_PATH as string,
      PRELOAD_DATA_LOCAL_STORAGE_KEY,
      [],
      ''
    )
      .then(() => {
        setPage('update_tutorial')
      })
      .catch((err) => {
        console.error(err)
        setPage('update_failed')
      })
      .finally(() => {
        setIsInstalling(false)
      })
  }
  return (
    <>
      {isOpen && page === 'confirm' && !isInstalling && (
        <MaintenancePageWrapper onClick={(e) => e.target === e.currentTarget && onClose()}>
          <ConfirmModal
            title="更新提醒"
            message="身份卡用于方便找回帐号，建议先下载保存身份卡，并请妥善保存避免泄漏。"
            cancelText="查看身份卡"
            confirmText="立即更新"
            type={CONFIRM_MODAL_TYPE.OK_CANCEL_CUSTOM}
            onCancel={() => setPage('user_card')}
            onConfirm={onClickUpdate}
          ></ConfirmModal>
        </MaintenancePageWrapper>
      )}
      {isOpen && page === 'user_card' && (
        <MaintenancePageWrapper onClick={(e) => e.target === e.currentTarget && setPage('confirm')}>
          <UserCardWrapper>
            <UserCard onClose={() => setPage('confirm')} />
          </UserCardWrapper>
        </MaintenancePageWrapper>
      )}
      {isOpen && page === 'update_tutorial' && (
        <MaintenancePageWrapper>
          <TutorialWrapper>
            <TutorialImg src={tutorialImg} />
            <BtnClose
              style={{ position: 'absolute', top: '0.4rem', right: '0.4rem' }}
              onClick={() => setPage('confirm')}
            />
          </TutorialWrapper>
        </MaintenancePageWrapper>
      )}
      {isOpen && page === 'update_failed' && (
        <MaintenancePageWrapper onClick={(e) => e.target === e.currentTarget && setPage('confirm')}>
          <ConfirmModal
            title="更新失败"
            message="网络开小差了，请检查连网状态后重试下哦"
            type={CONFIRM_MODAL_TYPE.OK}
            confirmText="确定"
            onConfirm={() => setPage('confirm')}
          />
        </MaintenancePageWrapper>
      )}
      {isInstalling && (
        <LoadingOverlay>
          <Loading>更新下载中...</Loading>
        </LoadingOverlay>
      )}
    </>
  )
}
